/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

// ------------------------------ SALIDAS -------------------------------------

export const ARDUINOUNO_salidas_led = (block, generator) => {
  const state = block.getFieldValue('STAT');
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_green_led_${pin}`] = `pinMode(${pin}, OUTPUT);`;
  return `digitalWrite(${pin}, ${state});\n`;
};

export const ARDUINOUNO_salidas_led_brillo = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const intensity = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || 0;
  generator.setups_[`setup_green_led_${pin}`] = `pinMode(${pin}, OUTPUT);`;
  return `analogWrite(${pin}, ${intensity});\n`;
};

export const ARDUINOUNO_ENTRADAS_piezo_buzzer_piano = (block) => {
  const value = block.getFieldValue('PIANO');
  const pin = block.getFieldValue('NPIN');
  return `tone(${pin || 2}, ${(value.basePitch * (value.octave === 3 ? 4 : value.octave)) || 165}, ${value.duration || 1000});\n`;
};

export const ARDUINOUNO_ENTRADAS_piezo_buzzer_variable = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const duration = generator.valueToCode(block, 'DURATION', generator.ORDER_NONE);
  const tone = generator.valueToCode(block, 'VAR', generator.ORDER_NONE);
  return `tone(${pin}, ${tone}, ${duration});\n`;
};

export const ARDUINOUNO_ENTRADAS_piezo_buzzerno = (block) => {
  const pin = block.getFieldValue('NPIN');
  return `noTone(${pin});\n`;
};

export const ARDUINOUNO_salidas_zumbador_activo = (block, generator) => {
  const state = block.getFieldValue('STAT');
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_zumbador_activo_${pin}`] = `pinMode(${pin}, OUTPUT);`;
  return `digitalWrite(${pin}, ${state});\n`;
};

export const ARDUINOUNO_salidas_laser = (block, generator) => {
  const state = block.getFieldValue('STAT');
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_laser_${pin}`] = `pinMode(${pin}, OUTPUT);`;
  return `digitalWrite(${pin}, ${state});\n`;
};

export const ARDUINOUNO_salidas_led_bicolor = (block, generator) => {
  const color = block.getFieldValue('STAT');
  const pinR = block.getFieldValue('NPIN');
  const pinY = block.getFieldValue('NPIN2');
  generator.setups_[`setup_ledbicolor_${pinR}_${pinY}`] = `pinMode(${pinR}, OUTPUT);\npinMode(${pinY}, OUTPUT);`;

  if (color === 'red') {
    return `digitalWrite(${pinR}, HIGH);\ndigitalWrite(${pinY}, LOW);\n`;
  }
  if (color === 'yellow') {
    return `digitalWrite(${pinR}, LOW);\ndigitalWrite(${pinY}, HIGH);\n`;
  }
  if (color === 'orange') {
    return `digitalWrite(${pinR}, HIGH);\ndigitalWrite(${pinY}, HIGH);\n`;
  }
  return '';
};

export const ARDUINOUNO_salidas_led_bicolor_apagar = (block, generator) => {
  const pinR = block.getFieldValue('NPIN');
  const pinY = block.getFieldValue('NPIN2');
  generator.setups_[`setup_ledbicolor_${pinR}_${pinY}`] = `pinMode(${pinR}, OUTPUT);\npinMode(${pinY}, OUTPUT);`;
  return `digitalWrite(${pinR}, LOW);\ndigitalWrite(${pinY}, LOW);\n`;
};

export const ARDUINOUNO_salidas_ledRGB = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || '';
  const pinR = block.getFieldValue('NPIN');
  const pinG = block.getFieldValue('NPIN2');
  const pinB = block.getFieldValue('NPIN3');
  const colour = color.split(', ');
  return `analogWrite(${pinR}, ${colour[0]});\nanalogWrite(${pinG}, ${colour[1]});\nanalogWrite(${pinB}, ${colour[2]});\n`;
};

export const ARDUINOUNO_salidas_rele = (block, generator) => {
  const state = block.getFieldValue('STAT');
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_rele_${pin}`] = `pinMode(${pin}, OUTPUT);`;
  return `digitalWrite(${pin}, ${state});\n`;
};

// ------------------------- ENTRADAS DIGITALES -------------------------------

export const ARDUINOUNO_ENTRADAS_button = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_button_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_button_touch = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_button_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_obstaculo = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_obstaculo_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_entradas_hall = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_hall_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_infrared = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_infrared_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_VIBRATION = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_vibration_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_TILT = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_tilt_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_CHOQUE = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_choque_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_GOLPE = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_golpe_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_INTERRUPTOR_OPTICO = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`setup_optico_${pin}`] = `pinMode(${pin}, INPUT);`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_entradas_ultrasonido = (block, generator) => {
  const triggerPin = block.getFieldValue('NPIN1');
  const echoPin = block.getFieldValue('NPIN2');

  generator.definitions_['define_SALIDAS_bat_u_tiempo'] = `
//sensor de ultrasonido
long u_tiempo(int trigger_pin, int echo_pin) {
    digitalWrite(trigger_pin, LOW);
    delayMicroseconds(2);
    digitalWrite(trigger_pin, HIGH);
    delayMicroseconds(10);
    digitalWrite(trigger_pin, LOW);
    long microseconds = pulseIn(echo_pin ,HIGH);
    return microseconds;
}
`;
  generator.definitions_['define_SALIDAS_bat_u_distancia'] = `
long u_distancia(int trigger_pin, int echo_pin) {
    long microseconds = u_tiempo(trigger_pin, echo_pin);
    long u_distancia;
    u_distancia = microseconds/29/2;
    if (u_distancia == 0){
        u_distancia = 999;
    }
    return u_distancia;
}
`;
  generator.setups_[`setup_SALIDAS_bat_${echoPin}${triggerPin}`] = `pinMode( ${echoPin} , INPUT );\n`;
  generator.setups_[`setup_SALIDAS_bat_2${triggerPin}${echoPin}`] = `pinMode( ${triggerPin} , OUTPUT );\n`;

  return [`u_distancia(${triggerPin}, ${echoPin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_SALIDAS_read_dht11 = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const type = block.getFieldValue('TYPE');

  generator.definitions_['define_SALIDAS_dht11'] = '#include <dht11.h>\n';
  generator.definitions_[`define_SALIDAS_dht11_${pin}`] = `dht11 DHT11${pin};\n#define DHT11PIN${pin} ${pin}\n\n`;
  generator.loop_[`dht11_${pin}`] = `DHT11${pin}.read(DHT11PIN${pin});`;

  const code = type === 'T' ? `DHT11${pin}.temperature` : `DHT11${pin}.humidity`;
  return [code, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_temperature = (block, generator) => {
  const pin = block.getFieldValue('NPIN');

  generator.definitions_['define_ENTRADAS_temperature'] = '#include <OneWire.h>\n#include <DallasTemperature.h>\n';
  generator.definitions_[`define_ENTRADAS_temperature_${pin}`] = `#define PinDS18B20${pin} ${pin}\nOneWire ourWire${pin}(PinDS18B20${pin});\nDallasTemperature sensors${pin}(&ourWire${pin});\n\n`;
  generator.setups_[`define_ENTRADAS_temperature_${pin}`] = `sensors${pin}.begin();\n`;
  generator.loop_[`ds18b20_${pin}`] = `sensors${pin}.requestTemperatures();`;

  return [`sensors${pin}.getTempCByIndex(0)`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_SALIDAS_IR = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const button = block.getFieldValue('NUM');

  generator.definitions_['define_SALIDAS_IR'] = `#include <IRremote.h>\n IRrecv ir_rx = ${pin};\ndecode_results ir_rx_results;\nunsigned long fnc_ir_rx_decode()\n{\nbool decoded=false;\nif( ir_rx.decode(&ir_rx_results))\n{\ndecoded=true;\nir_rx.resume();\n}\nif(decoded) return ir_rx_results.value;\n else return 0;\n}\n`;
  generator.setups_['define_SALIDAS_IR'] = '  ir_rx.enableIRIn();\n';

  return [`(unsigned long)fnc_ir_rx_decode() == ${button}`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_ENCODER = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const pin2 = block.getFieldValue('NPIN2');

  generator.setups_['setup_encoder_rotacion'] = `
int leerPosicion(int dt_, int clk_) {
  static int lecturaAnterior_;
  static int posicion_;
  int lecturaActual_ = digitalRead( dt_);
  if (lecturaActual_ != lecturaAnterior_) {
    if (digitalRead(clk_) != lecturaActual_) {
      posicion_ ++;
    } else {
      posicion_ --;
    }
    lecturaAnterior_ = lecturaActual_;
    return posicion_;
  }
}
`;
  generator.setups_[`setup_encoder_${pin}_${pin2}`] = `pinMode(${pin}, INPUT);\npinMode(${pin2}, INPUT);`;

  return [`leerPosicion(${pin}, ${pin2})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_follower = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const nextPin = block.getFieldValue('NPIN2');
  const code1 = generator.statementToCode(block, 'SENS1').replace(/&quot;/g, '"');
  const code2 = generator.statementToCode(block, 'SENS2').replace(/&quot;/g, '"');
  const code3 = generator.statementToCode(block, 'SENS3').replace(/&quot;/g, '"');

  generator.setups_[`setup_follower_1_${pin}`] = `pinMode( ${pin} , INPUT);\n`;
  generator.setups_[`setup_follower_2_${nextPin}`] = `pinMode( ${nextPin} , INPUT);\n`;

  return `if(digitalRead(${pin})==LOW)\n{\n  ${code1}\n}\nelse{\n    if(digitalRead(${nextPin})==LOW)\n    {\n  ${code2}\n    }else{\n\n${code3}    }\n}`;
};

// ------------------------ ENTRADAS ANALOGICAS -------------------------------

export const ARDUINOUNO_entradas_suelo = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_entradas_lluvia = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_potentiometer = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_photoresistor = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_entradas_sonido = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_FUEGO = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_PULSO = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_MAGNETICO = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_TEMPERATURA = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  generator.setups_['setup_temperatura_analogico'] = `
float leerTemp(int lectura_){
  float logTemp = log( 10000 * (1023.0 / (float)lectura_ - 1.0));
  float temp_ = (1.0 / (0.001129148 + 0.000234125*logTemp + 0.0000000876741*logTemp*logTemp*logTemp));
  temp_ = temp_ - 273.15;
  return temp_;
}
`;
  return [`leerTemp(analogRead(${pin}))`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_ENTRADAS_JOYSTICK = (block, generator) => {
  const axis = block.getFieldValue('NPIN');
  const pin = block.getFieldValue('NPIN2');
  if (axis !== 'a') {
    return [`analogRead(${pin})`, generator.ORDER_ATOMIC];
  }
  generator.setups_[`setup_joystick_${axis}_${pin}`] = `pinMode(${pin}, INPUT);\n`;
  return [`digitalRead(${pin})`, generator.ORDER_ATOMIC];
};

// ------------------------------ PANTALLA / LCD ------------------------------

const declareLcd = (generator, direction) => {
  generator.definitions_['declare_lcd'] = '\n#include <Wire.h>\n#include <LiquidCrystal_I2C.h>\n';
  generator.definitions_[`declare_lcd_${direction}`] = `\nLiquidCrystal_I2C lcd_${direction}(${direction}, 16, 2);\n`;
  generator.setups_[`setup_lcd_${direction}`] = `\n  lcd_${direction}.init();\n  lcd_${direction}.backlight();\n`;
};

export const ARDUINOUNO_lcd_educabot = (block, generator) => {
  const cursCol = block.getFieldValue('CURSOR_COLUMN');
  const cursRow = block.getFieldValue('CURSOR_ROW');
  const output = generator.valueToCode(block, 'NAME', generator.ORDER_ATOMIC) || '';
  const direction = block.getFieldValue('LCD_DIRECCION');
  declareLcd(generator, direction);
  return `\n  lcd_${direction}.setCursor(${cursCol}, ${cursRow});\n  lcd_${direction}.print(${output});\n`;
};

export const ARDUINOUNO_lcd_setBacklight = (block, generator) => {
  const state = block.getFieldValue('STATE');
  const direction = block.getFieldValue('LCD_DIRECCION');
  declareLcd(generator, direction);
  return `\n  lcd_${direction}.setBacklight(${state});\n`;
};

export const ARDUINOUNO_lcd_clear = (block, generator) => {
  const direction = block.getFieldValue('LCD_DIRECCION');
  declareLcd(generator, direction);
  return `\n  lcd_${direction}.clear();\n`;
};

// ------------------------------ MOTORES -------------------------------------

const includeServo = (generator, pin) => {
  generator.definitions_['include_servo'] = '#include <Servo.h>\n\n';
  generator.definitions_[`include_servo_${pin}`] = `Servo servo_${pin};\n`;
  generator.setups_[`servo_move_${pin}`] = `servo_${pin}.attach(${pin});`;
};

export const ARDUINOUNO_servo_move = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN') || '';
  includeServo(generator, pin);
  return `servo_${pin}.write(${angle});\n`;
};

export const ARDUINOUNO_servo_read = (block, generator) => {
  const pin = block.getFieldValue('NPIN') || '';
  includeServo(generator, pin);
  return [`servo_${pin}.read()`, generator.ORDER_ATOMIC];
};

export const ARDUINOUNO_SALIDAS_motor = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const action = block.getFieldValue('NPIN1');
  const motorAction = action === '6' ? 'LOW' : 'HIGH';
  generator.setups_[`motor_dc_${pin}`] = `\npinMode(${pin}, OUTPUT);\n`;
  return `\ndigitalWrite(${pin}, ${motorAction});\n`;
};

export const ARDUINOUNO_SALIDAS_motor_pwm = (block, generator) => {
  const pwm = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN');
  generator.setups_[`motor_dc_${pin}`] = `\npinMode(${pin}, OUTPUT);\n`;
  return `\nanalogWrite(${pin}, ${pwm});\n`;
};

export const ARDUINOUNO_SALIDAS_motor_doble = (block, generator) => {
  const pin1 = block.getFieldValue('NPIN0');
  const pin2 = block.getFieldValue('NPIN1');
  let dir1 = 'LOW';
  let dir2 = 'LOW';
  switch (block.getFieldValue('NPIN2')) {
    case '3': dir1 = 'HIGH'; dir2 = 'LOW'; break;
    case '4': dir1 = 'LOW'; dir2 = 'HIGH'; break;
    case '6': dir1 = 'LOW'; dir2 = 'LOW'; break;
    default: break;
  }
  generator.setups_[`${pin2}${pin1}`] = `pinMode(${pin1},OUTPUT);\n pinMode(${pin2},OUTPUT);\n`;
  return `digitalWrite(${pin1},${dir1});\n digitalWrite(${pin2},${dir2});\n`;
};

export const ARDUINOUNO_SALIDAS_motor_doble_pwm = (block, generator) => {
  const pwm = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC);
  const pin1 = block.getFieldValue('NPIN0');
  const pin2 = block.getFieldValue('NPIN1');
  let dir1 = '0';
  let dir2 = '0';
  switch (block.getFieldValue('NPIN2')) {
    case '3': dir1 = pwm; dir2 = '0'; break;
    case '4': dir1 = '0'; dir2 = pwm; break;
    case '6': dir1 = '0'; dir2 = '0'; break;
    default: break;
  }
  generator.setups_[`${pin2}${pin1}`] = `pinMode(${pin1},OUTPUT);\n pinMode(${pin2},OUTPUT);\n`;
  return `analogWrite(${pin1},${dir1});\n analogWrite(${pin2},${dir2});\n`;
};
